module.exports = __webpack_public_path__ + "img/logo2.8eb2916e.png";